// import { Document, Page } from "react-pdf";
// import { useState } from "react";

// export default function PdfThumbnail({ file, onClick }) {
//   const [numPages, setNumPages] = useState(null);

//   return (
//     <div onClick={onClick} style={{ cursor: "pointer" }}>
//       <Document
//         file={{
//           url: file,
//           withCredentials: false,
//         }}
//         onLoadSuccess={({ numPages }) => setNumPages(numPages)}
//         onLoadError={(e) => console.error("PDF load error:", e)}
//       >
//         <Page
//           pageNumber={1}
//           width={160}
//           renderTextLayer={false}
//           renderAnnotationLayer={false}
//         />
//       </Document>
//     </div>
//   );
// }

import { Document, Page } from "react-pdf";
import React, { useContext, useEffect, useState, useRef } from "react";


export default function PdfThumbnail({ file, onClick }) {
  const [numPages, setNumPages] = useState(null);

  return (
    <div onClick={onClick} style={{ cursor: "pointer", width: 160 }}>
      <Document
        file={file}
        onLoadSuccess={({ numPages }) => setNumPages(numPages)}
        onLoadError={(err) => console.error("PDF load error:", err)}
      >
        <Page
          pageNumber={1}
        //   width={160}
          height={200}
        // scale={0.3}
          renderTextLayer={false}
          renderAnnotationLayer={false}
        />
      </Document>
    </div>
  );
}

